/**
 * Что из правки карточки не сохранилось, потому что то же поле успел изменить
 * другой человек (задача 0313).
 *
 * <p>Ответ владельца продукта 17.10.2026 дословно: «не сохраняются только
 * конфликтные поля, а остальные сохраняются». Сервер отвечает 200 и называет
 * несохранённое в `notSaved`; слова экрана об этом живут здесь, в одном месте.
 */
export interface NotSavedField {
  /** Ключ поля формы — по нему находится строка. */
  key: string;
  /** Подпись строки, словами формы. */
  label: string;
  /**
   * Подпись поля, которое изменил другой. У занятого поля — оно само;
   * у второго поля связки (номер производителя и кросс-номера пишутся только
   * вместе) — то, из-за которого связку не записали.
   */
  cause: string;
}

/** Сводка над формой: «Не сохранено: Цена. Остальное сохранено». */
export function notSavedSummary(fields: readonly NotSavedField[]): string {
  return `Не сохранено: ${fields.map((f) => f.label).join(', ')}. Остальное сохранено`;
}

/** Слова у несохранённой строки — что случилось и что делать. */
export function notSavedNote(field: NotSavedField): string {
  const why = field.cause === field.label
    ? 'другой человек уже изменил это поле'
    : `оно сохраняется только вместе с полем «${field.cause}», а его уже изменил другой человек`;
  return `Не сохранено: ${why}. Перезагрузите страницу и повторите правку`;
}
